import YoutubeVideo from '@components/ui/youtube-video/youtube-video';
export default YoutubeVideo;
